var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TrackerDataTableItemEdit',_vm._b({scopedSlots:_vm._u([{key:"titleSlot",fn:function({ itemDTO }){return [(_vm.userCanAccessHubspot())?_c('Company2HubspotSelector',{attrs:{"itemDTO":itemDTO,"configuration":_vm.trackerType}}):_vm._e()]}}])},'TrackerDataTableItemEdit',[_vm.$props, _vm.$attrs],false))
}
var staticRenderFns = []

export { render, staticRenderFns }